import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/events`;

export const getEventList = async () => {
    const response = await axios.get(API_BASE_URL);
    return response.data;
};

export const getEvent = async (eventId) => {
    const response = await axios.get(`${API_BASE_URL}/${eventId}`);
    return response.data;
};